import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";

import { CssBaseline, Grid, Typography } from "@mui/material";
import Modal from "@instream-solutions/instream-design-system/lib/UX/Modal/Modal";
import PrivacyPolicy from "../../components/Modules/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../../components/Modules/TermsAndConditions/TermsAndConditions";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: #546E7A !important;
  }
`;

const Root = styled.div`
  max-width: 62%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

const AuthFooter = (props) => {
  const [state, setState] = useState({
    showPrivacyPolicy: false,
    showTermsAndConditions: false,
  });

  return (
    <React.Fragment>
      <div className={"instream-login-footer"}>
        <Typography className={"signin-patent-pending"}>
          &copy; 2023 Engage. A division of WealthCentral. All Rights Reserved.
        </Typography>
        <ul className={"signin-page-footer"}>
          <li>
            <a href="https://vestevo.zendesk.com/hc/en-us" target={"_blank"}>
              Support
            </a>
          </li>
          <li>
            <a
              href={"#"}
              onClick={() => {
                setState({
                  ...state,
                  showPrivacyPolicy: true,
                });
              }}
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              href={"#"}
              onClick={() => {
                setState({
                  ...state,
                  showTermsAndConditions: true,
                });
              }}
            >
              Terms of Service
            </a>
          </li>
        </ul>
      </div>
      {state.showPrivacyPolicy && (
        <Modal
          onCancel={() => {
            setState({
              ...state,
              showPrivacyPolicy: false,
            });
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} className={"modal-info-container"}>
              <PrivacyPolicy
                onClose={() => {
                  setState({
                    ...state,
                    showPrivacyPolicy: false,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Modal>
      )}
      {state.showTermsAndConditions && (
        <Modal
          onCancel={() => {
            setState({
              ...state,
              showTermsAndConditions: false,
            });
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} className={"modal-info-container"}>
              <TermsAndConditions
                onClose={() => {
                  setState({
                    ...state,
                    showTermsAndConditions: false,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Modal>
      )}
    </React.Fragment>
  );
};

function Auth({ children }) {
  return (
    <React.Fragment>
      <Root>
        <CssBaseline />
        <GlobalStyle />
        {children}
      </Root>
      <AuthFooter />
    </React.Fragment>
  );
}

export default Auth;
